// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"56":"dff5567d","268":"b2ca2d78","526":"86920dc8","925":"1981ddf1"}[chunkId] + ".css";
};